/** Visual paths and minimap routes over Greenvale's existing authoritative terrain. */
export const starterRoads: readonly (readonly [number, number, number, number, number])[] = [
  [8, 110, 24, 110, 2.4],
  [24, 110, 33, 118, 2.4],
  [0, 12, 8, 12, 2.4],
  [0, 110, 8, 110, 2.4],
  [42, 0, 42, 38, 2.8],
  [42, 38, 63, 38, 2.8],
  [63, 38, 75, 27, 2.8],
  [0, -28, 0, 112, 7],
  [-24, 0, 112, 0, 7],
  [0, -28, 4, -80, 5],
  [4, -80, -5, -95, 5],
  [0, -28, -15, -32, 4],
  [-15, -32, -34, -34, 4],
  [-34, -34, -62, -62, 4],
  [0, -10, 8, -14, 3],
  [0, 6, -6, 6, 3],
  [-8, -90, -25, -88, 2.4],
  [-25, -88, -40, -90, 2.4],
  [-40, -90, -57, -92, 2.4],
  [-57, -92, -76, -92, 2.4],
  [-76, -92, -93, -82, 2.4],
];
